import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ...l }, /* @__PURE__ */ e.createElement("path", { fill: "#86868B", fillRule: "evenodd", d: "M14.442 17.942a.625.625 0 0 0 0-.884L9.884 12.5l4.558-4.558a.625.625 0 1 0-.884-.884l-5 5a.625.625 0 0 0 0 .884l5 5c.244.244.64.244.884 0Z", clipRule: "evenodd" }));
export {
  t as default
};
